export default __webpack_public_path__ + "static/media/experiment.66ceda05.png";